<script>import { attrValue } from "../../../../utils/html";
import ButtonLabeled from "./ButtonLabeled.svelte";
export let props = {};
$: props = { ...props, classNames: attrValue([props.classNames]) };
</script>

<ButtonLabeled bind:props on:click />
